<template>
    <div>
        <div class="header">
            <div class="logout-bg" @click="logout">
                メニューに戻る
            </div>
            <div class="header-countdown-time">
                {{ countdownTimeStr }}
            </div>
            <div class="header-title">お客様履歴検索</div>

        </div>
        <div class="div-customer-search">
            <input class="input-customer-name" placeholder="お名前をカタカナで入力" v-model="searchKey"
            >
            <div class="btn-bg-search" @click="searchCustomer">検索</div>
        </div>
        <div class="container" style="overflow-y: auto;">

            <table >
              <thead>
                <tr>
                  <th class="container-th" style="position: sticky;z-index: 1;top:-2px;" v-for="item in columns" v-bind:key="item.field">{{ item.label }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in rows" v-bind:key="item.customerId"
                    :class="selectedIndex===index?'container-tr-bg-3':index%2===0?'container-tr-bg':'container-tr-bg-2'">
                  <div :class="selectedIndex===index?'container-tr-id-selected':'container-tr-id'">
                    <a :class="selectedIndex===index?'container-tr-id-text-selected':'container-tr-id-text'"
                       href="#" @click="itemClick(index,item.customerId)">{{ item.customerId }}</a></div>
                  <div :class="selectedIndex===index?'container-tr-content-selected':'container-tr-content'">{{ dataShow?item.name+" "+item.customerName:"*** ***" }}</div>
                  <div :class="selectedIndex===index?'container-tr-content-selected':'container-tr-content'">{{ dataShow?item.customerTelnumber :"*** ***" }}</div>
                  <div :class="selectedIndex===index?'container-tr-content-selected':'container-tr-content'">{{ item.ssName }}</div>
                </tr>
              </tbody>


            </table>
            <div v-if="rows.length === 0" class="container-empty">該当データはありません</div>
        </div>
        <div class="btn-bg" @click="addNewCustomer">
            お客様の新規登録
        </div>
        <div class="btn-bg" @click="hideData">
            {{dataShow?"お客様情報を非表示にする":"お客様情報を表示する"}}
        </div>
        <custom-dialog v-show="showMessage" :show-message="showMessage" :sub-message='subMessage'
                       @dialogClick="dialogClick" :type="dialogType"/>
    </div>
</template>
<script>

import {EXIT_DATA_SAVE_TIPS} from "@/store/message";
import CustomDialog from "@/components/CustomDialog.vue";
import {getToken} from "@/utils/request";
import {searchCustomerList, getSsInfo} from "@/utils/api";
import {SHOP_ID} from "@/store/mutation-types";

export default {
    name: 'customerIndex',
    components: {
        CustomDialog
    },
    data() {
        return {
          katagana: /[^アイウエオカキクケコャュョガギグゲゴサシスセソザジズゼゾェタティトゥダデドチヂツァォヅナニヌネノハヒホヘバビブベボパピプぺポフマミムメモヤ㇙ユヨッラリルレロワヰ于ヱヲヷヸヴヹヺンーヵヶ]/g,
          countdownTime: 600,
            countdownTimeStr: '',
            searchKey:'',
            columns: [
                {
                    label: 'お客様ID',
                    field: 'customerId',
                },
                {
                    label: '氏名',
                    field: 'customerName',
                },
                {
                    label: '電話番号',
                    field: 'customerTelnumber',
                },
                {
                    label: '登録店',
                    field: 'ssName',
                }
            ],
            selectedIndex:-1,
            dataShow:true,
            rows:[],
            // rows: [
            //     {
            //         "customerId": 1,
            //         "customerName": "孝之",
            //         "name": "望月",
            //         "customerTelnumber": "000-000-0000",
            //         "ssName": "石坂SS",
            //     },
            //     {
            //         "customerId": 2,
            //         "customerName": "孝之",
            //         "name": "望月",
            //         "customerTelnumber": "000-000-0000",
            //         "ssName": "石坂SS",
            //     },
            //     {
            //         "customerId": 3,
            //         "customerName": "孝之",
            //         "name": "望月",
            //         "customerTelnumber": "000-000-0000",
            //         "ssName": "石坂SS",
            //     }, {
            //         "customerId": 4,
            //         "customerName": "孝之",
            //         "name": "望月",
            //         "customerTelnumber": "000-000-0000",
            //         "ssName": "石坂SS",
            //     },
            //     {
            //         "customerId": 5,
            //         "customerName": "孝之",
            //         "name": "望月",
            //         "customerTelnumber": "000-000-0000",
            //         "ssName": "石坂SS",
            //     },
            //     {
            //         "customerId": 6,
            //         "customerName": "孝之",
            //         "name": "望月",
            //         "customerTelnumber": "000-000-0000",
            //         "ssName": "石坂SS",
            //     },
            //     {
            //         "customerId": 7,
            //         "customerName": "孝之",
            //         "name": "望月",
            //         "customerTelnumber": "000-000-0000",
            //         "ssName": "石坂SS",
            //     },
            //     {
            //         "customerId": 8,
            //         "customerName": "孝之",
            //         "name": "望月",
            //         "customerTelnumber": "000-000-0000",
            //         "ssName": "石坂SS",
            //     },
            //     {
            //         "customerId": 9,
            //         "customerName": "孝之",
            //         "name": "望月",
            //         "customerTelnumber": "000-000-0000",
            //         "ssName": "石坂SS",
            //     },
            //     {
            //         "customerId": 10,
            //         "customerName": "孝之",
            //         "name": "望月",
            //         "customerTelnumber": "000-000-0000",
            //         "ssName": "石坂SS",
            //     }
            // ],

            dialogType: 0,
            showMessage: false,
            subMessage: "",
            state: 0,
            taskId:null
        }
    },
  watch: {
    'searchKey' : {
      handler: function (newVal) {
        if (newVal && newVal != '') {
          console.log('new '+newVal)
          this.searchKey = newVal.replaceAll(this.katagana, '');
        }
      }
    },
  },
    mounted() {
        let that = this;
        that.taskId = setInterval( function(){
            that.countdown();

        }, 1000);
        if (that.$route.params.shopId){
            console.log('shopId',that.$route.params.shopId);
            localStorage.setItem(SHOP_ID,that.$route.params.shopId)
        }
        else {
            console.log("no request shopId");
            // TODO: get ssid from login user
            getSsInfo()
                .then((res) => {
                    console.log(JSON.stringify(res));
                    if (res.ret == 200) {
                        console.log('session shopId',res.data.ID);
                        localStorage.setItem(SHOP_ID,res.data.ID)
                    }
                    // else {
                    //     window.location.href = "/ss";
                    // }
                })
                .catch((res) => {
                    console.log(res);
                    // window.location.href = "/ss";
                })
        }
    },
    beforeDestroy() {
        clearInterval(this.taskId)
    },
    created() {
        let that = this;
        getToken();
        document.addEventListener('touchstart', function () {
            that.handleTouchStart()
        }, true);
        that.showMessageDialog('お客様情報の有無を確認します。',1)

    },
    methods: {
        rowClick(row,rowIndex,column){
          console.log('row'+row)
          console.log('rowIndex'+rowIndex)
          console.log('column'+column)
          this.selectedIndex = rowIndex;
        },
        getRowClass({row, rowIndex}) {
          console.log('row'+row)
          if (rowIndex == this.selectedIndex){
            return "tableRowSelected";
          }else if(rowIndex % 2 == 0) {
            return "tableRowOdd";
          }
          else {
            return "tableRowEven";
          }
        },
        countdown(){
            let that = this;
            let diff = that.countdownTime;
            diff--;
            if (diff <= 0) {
                window.document.location = "/ss/menu.php";
                clearInterval(that.taskId)
                return
            }

            let minutes = Math.floor((diff  / 60));
            let seconds = Math.floor((diff % 60));
            that.$set(that, 'countdownTimeStr',  `${minutes}:${seconds<10?'0'+seconds:seconds}`)
            that.$set(that, 'countdownTime',  diff)
        },
        handleTouchStart() {
            console.log('handleTouchStart')
            if (this.countdownTime!==600){
                this.$set(this, 'countdownTime',  600)
            }
        },
        logout() {
            this.state = -1;
            this.showMessageDialog("入力途中のデータは\n保存されません", 2)

        },
        back() {
            this.state = -2;
            this.showMessageDialog(EXIT_DATA_SAVE_TIPS, 2)
        },
        dialogClick(val) {
            this.$set(this, 'showMessage', false)
            this.$set(this, 'subMessage', '')
            if (val) {
                console.log('this.state:'+this.state);
                if (this.state === -1) {
                    window.document.location = "/ss/menu.php";
                } else if (this.state === -2) {
                    this.$router.back();
                }
            }
            this.$set(this, 'state', 0)
        },
        showMessageDialog(subMessage, dialogType) {
            this.$set(this, 'showMessage', true)
            this.$set(this, 'dialogType', dialogType)
            this.$set(this, 'subMessage', subMessage)
        },
        hideData(){
            if (this.dataShow){
                this.$set(this, 'dataShow', false)
            }else {
                this.$set(this, 'dataShow', true)
            }
        },
        addNewCustomer(){
            this.$router.push('/addNewCustomer')
        },
        searchCustomer(){
            let that = this;
            if (that.searchKey){
                const loadingInstance1 = that.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                });
                searchCustomerList(that.searchKey)
                    .then(function (res) {
                        console.log(JSON.stringify(res));
                        if (res && res.data && res.data.length > 0){
                            that.$set(that,'rows',res.data)
                        }else {
                            that.$set(that,'rows',[])
                        }
                        loadingInstance1.close();
                    })
                    .catch(function (err){
                        console.error(err)
                        loadingInstance1.close();
                    });
            }else {
                this.state = 1;
                this.showMessageDialog('お名前のカタカナを入力してください', 1)
            }
        },
        itemClick(index,customerId){
            this.$set(this, 'selectedIndex', index)
            this.$router.push('/carSearchIndex/'+customerId)
        }

    }
}
</script>

<style scoped>
.header {
    background: #416ADB;
    height: 8vw;
}

.header-title {
    color: white;
    font-size: 3vw;
    height: 8vw;
    line-height: 8vw;
    margin: 0 auto;
}

.header-countdown-time {
    display: flex;
    color: white;
    font-size: 2.2vw;
    position: absolute;
    float: right;
    right: 0;
    margin-top: 1.5vw;
    margin-right: 3.5vw;
}

.container {
    text-align: center;
    height: 40vh;
    margin: 1vw auto;
    overflow:auto;
}
.container-empty{
    width: 100%;
    padding-top: 5vh;
    text-align: center;
    margin: 0 auto;
    font-size: 2.4vw;
}
.container-th {
    min-width: 22vw;
    background: #89a4ca;
    color: #FFFFFF;
    font-size: 2.4vw;
    padding: 0.8vw;
    border-right: 0.1vw solid #FFFFFF;
    display: table-cell;
}
.container-tr-id{
    min-width: 22vw;
    font-size: 2.4vw;
    padding: 0.8vw;
    color: #083a7e;
    border-right: 0.1vw solid #FFFFFF;
    display: table-cell;
}
.container-tr-id-selected{
    min-width: 22vw;
    font-size: 2.4vw;
    padding: 0.8vw;
    color: #ffffff;
    border-right: 0.1vw solid #FFFFFF;
    display: table-cell;
}
.container-tr-id-text{
    color: #083a7e;
}
.container-tr-id-text-selected{
    color: #ffffff;
}
.container-tr-content-selected{
    font-size: 2.4vw;
    min-width: 22vw;
    padding: 0.8vw;
    text-align: left;
    color:#FFFFFF;
    border-right: 0.1vw solid #FFFFFF;
    display: table-cell;
    overflow: hidden;

}
.container-tr-content{
    min-width: 22vw;
    font-size: 2.4vw;
    padding: 0.8vw;
    text-align: left;
    border-right: 0.1vw solid #FFFFFF;
    display: table-cell;
  overflow: hidden;
}
.container-tr-bg{
    background: #cfddee;
}
.container-tr-bg-2{
    background: #e8f1fb;
}
.container-tr-bg-3{
    background: #083a7e;
}

.div-customer-search {
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2vw;
}

.input-customer-name {
    padding-left: 1vw;
    width: 50vw;
    border: 0.3vw #083A7E solid;
    border-radius: 0.8vw;
    color: #212529;
    padding-top: 1vw;
    padding-bottom: 1vw;
    font-size: 2.4vw;
}

.btn-bg-search {
    margin-left: 3vw;
    background: #f7bc34;
    font-size: 2.6vw;
    text-align: center;
    align-items: center;
    padding: 1vw 2.5vw 1vw 2.5vw;
    border-radius: 0.8vw;
    color: #212529;
    border-width: 0.4vw;
    border-color: #93721f;
    border-style: none none solid none;
}

.logout-bg {
    margin: 1.5vw 3vw;
    background: #e7373d;
    font-size: 2.4vw;
    padding: 0.8vw 5vw;
    border-radius: 0.8vw;
    color: #FFFFFF;
    border-width: 0.4vw;
    border-color: #891F25;
    border-style: none none solid none;
    position: absolute;
}

.btn-bg {
    margin: 2vw auto;
    padding: 1vw;
    border-radius: 1vw;
    opacity: 1;
    border-bottom: #083A7E 0.2vw;
    border-style: none none solid none;
    background: #416ADA;
    color: #FFFFFF;
    font-size: 2.6vw;
    width: 40vw;
}
:deep(.el-table::before){
  height: 0 !important;
}

:deep(.tableHeader){
  background-color: #89a4ca;
  color: #FFFFFF;
  font-size: 1.5rem;
}
:deep(.el-table__cell){
  padding: 0.2em!important;
  font-weight: 100;
}

:deep(.tableHeaderCell){
  background-color: transparent !important;
  color: #FFFFFF;
  font-size: 1.5rem;
  line-height: 50px !important;
}
:deep(.tableCell){
  font-size: 1.5rem;
  color: #212529;
}
:deep(.tableRowOdd){
  background-color: #cfddee;
}

:deep(.tableRowEven){
  background-color: #e8f1fb;
}
#table-header {
  position: -webkit-sticky; /* Safari 支持 */
  position: sticky;
  top: 1vw; /* 距离顶部的位置 */
  background-color: #f8f8f8; /* 背景颜色，以保持表头的可读性 */
  z-index: 1000; /* 确保表头在其他元素之上 */
}

/*/deep/ .el-table__body tr.current-row>td.el-table__cell{
  color: #FFFFFF;
  background-color: #083a7e;
}*/
</style>